// src/components/Home/HeroCarousel.js
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import HeroSlide from './HeroMainSlide';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HeroCarousel = () => {
  return (
    <div className="hero-carousel-container h-[800px] relative">
      {/* Gradient overlay that fades from top (dark) to bottom (transparent) */}
      <div className="absolute inset-x-0 top-0 h-[200px] bg-gradient-to-b from-black to-transparent z-10 pointer-events-none"></div>
      
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 500000, disableOnInteraction: false }}
        loop={true}
        className="h-full"
      >
        {/* First slide - Current Hero */}
        <SwiperSlide>
          <HeroSlide />
        </SwiperSlide>
        
        {/* Second slide - Video 1 */}
        {/* <SwiperSlide>
          <div className="relative h-full bg-black flex items-center justify-center">
            <video 
              className="w-full h-full object-cover" 
              autoPlay 
              muted 
              loop
            >
              <source src="/path/to/your/video1.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center">
              <div className="text-center w-full text-white px-4">
                <h2 className="text-4xl font-bold mb-4">TRANSFORMAMOS LA FORMA EN QUE TRABAJAS, VENDES O VIVES</h2>
                <p className="text-xl max-w-2xl mx-auto">
                  No solo vendemos servicios, ofrecemos soluciones reales que transforman la forma en que trabajas, vendes o vives.
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide> */}
        
        {/* Third slide - Video 2 */}
        {/* <SwiperSlide>
          <div className="relative h-full bg-black flex items-center justify-center">
            <video 
              className="w-full h-full object-cover" 
              autoPlay 
              muted 
              loop
            >
              <source src="/path/to/your/video2.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center">
              <div className="text-center w-full text-white px-4">
                <h2 className="text-4xl font-bold mb-4">SOLUCIONES REALES</h2>
                <p className="text-xl max-w-2xl mx-auto">
                  Porque no solo vendemos servicios, ofrecemos soluciones reales a través de tecnología, estrategia y energía.
                </p>
              </div>
            </div>
          </div>
        </SwiperSlide> */}
      </Swiper>
    </div>
  );
};

export default HeroCarousel;
